var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThreeDots = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 4,
  height: 19,
  fill: "none",
  viewBox: "0 0 4 19"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 2.5,
  r: 2,
  fill: "#797F89"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 9.5,
  r: 2,
  fill: "#797F89"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 2,
  cy: 16.5,
  r: 2,
  fill: "#797F89"
})));
export { SvgThreeDots as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNCIgaGVpZ2h0PSIxOSIgdmlld0JveD0iMCAwIDQgMTkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjIiIGN5PSIyLjUiIHI9IjIiIGZpbGw9IiM3OTdGODkiLz4KPGNpcmNsZSBjeD0iMiIgY3k9IjkuNSIgcj0iMiIgZmlsbD0iIzc5N0Y4OSIvPgo8Y2lyY2xlIGN4PSIyIiBjeT0iMTYuNSIgcj0iMiIgZmlsbD0iIzc5N0Y4OSIvPgo8L3N2Zz4K";